import React, { useContext } from "react";
import GlobalContext from "../../context/global";
import DisclaimerText from "./DisclaimerText";

const Consent = () => {
  const appData = useContext(GlobalContext);
  const { isCDTT } = appData;

  return (
    <div className="row">
      <div className="col-12 mb-4 text-center fs-px-14 text-gray-550 font-weight-normal">
        <p className="mb-0">
          <DisclaimerText isCDTT={isCDTT} />
        </p>
      </div>
    </div>
  );
};

export default Consent;
